import { Component } from '@angular/core';

@Component({
  selector: 'tln-ats-logo',
  styleUrl: './ats-logo.component.less',
  templateUrl: './ats-logo.component.html',
  standalone: true,
})
export class AtsLogoComponent {}
